import {
  DIMENSION_SCORE_COLOR_TOKENS,
  DimensionScoreLevelName,
} from '@backrs_ui/common-ui/src/models/trackAssessment';

import { Box, SxProps, Theme, Typography } from '@mui/material';

type DimensionScorePillProps = Readonly<{
  score: DimensionScoreLevelName;
  label: string;
  sx?: SxProps<Theme>;
}>;

export const DimensionScorePill = ({ score, label, sx }: DimensionScorePillProps) => {
  return (
    <Box sx={[pillSx(score), ...(Array.isArray(sx) ? sx : [sx])]}>
      <Typography variant="text-xs-medium">{label}</Typography>
    </Box>
  );
};

const pillSx =
  (score: DimensionScoreLevelName): SxProps<Theme> =>
  ({ backrs }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    px: backrs.spacing['spacing-sm'],
    py: backrs.spacing['spacing-xxs'],
    borderRadius: backrs.radius['radius-full'],
    backgroundColor: backrs.colors[DIMENSION_SCORE_COLOR_TOKENS[score]],
    border: `1px solid ${backrs.colors['Colors/Base/Black']}`,
    color: backrs.colors['Colors/Base/Black'],
  });
